import { Spacer } from 'fastdo-react'

import MoveUpAnimation from '../components/MoveUpAnimation'
import PageBase from '../components/PageBase'
import { useAppT } from '../localization/config'

export default function ServicesPage() {
  const t = useAppT()

  return (
    <PageBase title={t.services_title} subtitle={t.services_subtitle} scroolToTop>
      <MoveUpAnimation>
        <p>{t.services_text}</p>

        <ul className="list-[circle] mt-4">
          <li>{t.services_item_1}</li>
          <li>{t.services_item_2}</li>
          <li>{t.services_item_3}</li>
          <li>{t.services_item_4} ✨</li>
        </ul>
      </MoveUpAnimation>

      <Spacer size={30} />

      <MoveUpAnimation>
        <h2>
          {t.peak_title} ({t.peak_subtitle})
        </h2>

        <p>{t.peak_text}</p>

        <ul className="list-[circle] mt-4">
          <li>{t.peak_item_1}</li>
          <li>{t.peak_item_2} ✨</li>
        </ul>
      </MoveUpAnimation>
    </PageBase>
  )
}
